import { useTranslation } from 'react-i18next'
import { OptionButton } from './OptionButton'
import type { MultiSelectPage } from '@/content/quiz/types'
import { SocialProofBlock } from './SocialProofBlock'

interface MultiSelectQuestionProps {
  page: MultiSelectPage
  value?: string[]
  onSelect: (value: string[]) => void
}

export function MultiSelectQuestion({ page, value = [], onSelect }: MultiSelectQuestionProps) {
  const toggle = (optionValue: string) => {
    const next = value.includes(optionValue)
      ? value.filter((v) => v !== optionValue)
      : [...value, optionValue]
    onSelect(next)
  }

  return (
    <div className="space-y-6 flex flex-col items-center">
      <h2 className="text-xl font-semibold text-slate-900">{page.question}</h2>
      <div className="space-y-2 w-full">
        {page.options.map((option) => (
          <OptionButton
            key={option.value}
            option={option}
            selected={value.includes(option.value)}
            onClick={() => toggle(option.value)}
          />
        ))}
      </div>
      {page.socialProof && (
        <SocialProofBlock config={page.socialProof} className="mt-8" />
      )}
    </div>
  )
}
